/* eslint-disable max-len */
import React from 'react';
import Text from '@amzn/meridian/text';
import PropTypes from 'prop-types';
import colorStyles from '../enums/colorStyles';
import { CgAsterisk } from 'react-icons/cg';

const Question = ({ questionTextFormat, question, isMandatory }) => (
    <Text type={questionTextFormat}>
    {question}
    {isMandatory && (
      <CgAsterisk aria-label="required" color={colorStyles.REQUIRED} />
    )}
  </Text>
);

Question.propTypes = {
    questionTextFormat: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    isMandatory: PropTypes.bool.isRequired,
};

export default Question;
